import React, { useEffect, useState } from 'react';
import counterStore from './CounterStore';
import './App.css';
var Counter = function () {
    var _a = useState(counterStore.getCounter()), value = _a[0], setValue = _a[1];
    useEffect(function () {
        var subId = counterStore.subscribe(function () { return setValue(counterStore.getCounter()); });
        console.log("subscribe with id: " + subId);
        return function () {
            console.log("unsubscribe with id: " + subId);
            counterStore.unsubscribe(subId);
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("h1", null,
            value,
            " "),
        React.createElement("button", { onClick: function () { return counterStore.increase(); } }, "+ 1"),
        React.createElement("button", { className: "asyncButton", onClick: function () { return counterStore.increaseAsync(); } }, "+ 1 Async")));
};
function App() {
    var _a = useState(false), hide = _a[0], setHide = _a[1];
    var handleButton = function () {
        setHide(!hide);
    };
    return (React.createElement("div", { className: "App" },
        React.createElement("h1", null, "Counter App"),
        React.createElement("div", { className: "action-bar" },
            React.createElement("button", { className: "subscribe-button", onClick: handleButton }, hide ? "Subscribe" : "Unsubscribe")),
        !hide && React.createElement(Counter, null)));
}
export default App;
